import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  requests: [],
  queryResults: [],
  errore: null,
};

const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaRequests(state, action) {
      state.requests = action.payload;
    },
    aggiornaQueryResults(state, action) {
      state.queryResults = action.payload;
    },
    errore(state, action) {
      state.errore = action.payload;
    },
    resetErrore(state) {
      state.errore = null;
    },
  },
});

export const { caricamento, aggiornaRequests, aggiornaQueryResults, errore, resetErrore } = requestsSlice.actions;
const requestsReducer = requestsSlice.reducer;

export default requestsReducer;

